module.exports = __webpack_public_path__ + "static/media/mum_cutting_grass_nt.39176e6b.gif";